import React, { useState, useEffect, useContext } from 'react';
import konsole from '../../network/konsole';
import Services from '../../network/Services';
import commonLib from '../../control/commonLib';
import { UserContext } from "../../App.js";
import { Viewandupdatemodal } from './Viewandupdatemodal';
import "./communication.css"

function BasicExample(props) {

  const [showAddModal, setShowAddModal] = useState(false)
  const [selectedRowData, setSelectedRowData] = useState([])
  const [subtenantID, setSubtenantID] = useState()
  const [emptyState, setEmptyState] = useState()
  const [updateTableData, setupdateTableData] = useState(false)
  const [inblidEmailTemplate, setInblidEmailTemplate] = useState([])
  const [sortedData, setsortedData] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const pageSize = 10

  const { setLoader } = useContext(UserContext)

  useEffect(() => {
    let subtenantIDd = commonLib.getSessionStoarge("subtenantId")
    setSubtenantID(subtenantIDd)
  }, [])

  useEffect(() => {
    if (updateTableData == true) {
      props.GetCommMediumPathApiFuction()
      setupdateTableData(false)
    }
  }, [updateTableData])

  useEffect(() => {
    if (subtenantID && !updateTableData) getEmailTemplatesPathApiFunction(subtenantID)
  }, [subtenantID, selectedRowData?.applicableEmailTempId, updateTableData])

  const handleClose = () => {
    setEmptyState({})
    props.GetCommMediumPathApiFuction()
    getEmailTemplatesPathApiFunction(subtenantID)
    setShowAddModal(false);
  }

  useEffect(() => {
    let newData = props.GetCommMediumData.sort((a, b) => a.occurrenceDetails.localeCompare(b.occurrenceDetails));
    setsortedData(newData)
    setCurrentPage(1)
  }, [props.GetCommMediumData])

  const addEditModalFun = (rowData) => {
    setShowAddModal(true)
    setSelectedRowData(rowData)
  }

  const getEmailTemplatesPathApiFunction = (subtenantID) => {
    const promises = Services.getEmailTemplatesPathApi(subtenantID)
    promises.then((response) => {
      setInblidEmailTemplate(response?.data?.data);
    }).catch((error) => {
      konsole.log("error", error);
    }).finally(() => {
      konsole.log("finish");
    });
  };

    //Api Code start 

  // const GetCommMediumPathApiFuction = (subtenantID) => {
  //   // alert("communication table inside")
  //   const promises = Services.GetCommMediumPathApi(2)
  //   promises.then((response) => {

  //     konsole.log("GetCommMediumPathApiljljllj;", response);
  //     // setLoader(true)

  //     setCommMediumData(response.data.data);
  //     let arr = [];
  //     let i
  //     for (i = 0; i < GetCommMediumData.length - 1; i++) {
  //       // 
  //       arr.push(response.data.data[i]?.commMediumRoles)
  //     }
  //     // konsole.log("arrr", arr)
  //     setCommMediumRoles(arr)

  //   })
  //     .catch((error) => {
  //       konsole.log("error", error);
  //     })
  //     .finally(() => {
  //       konsole.log("finish");
  //       // props.GetCommMediumPathApiFuction()

  //     });
  // };

  // setTimeout(() => {
  //   setLoader(false)
  // }, 3000)
  // }).catch((err) => {
  //   konsole.log("err", err);
  // }).finally(()=>{
  //   konsole.log("Finish")
  //   setLoader(false)

  // })
  // };






  const PutUpsertCommMediumApiFuctioniOnOFF = (e, rowOnOffData) => {
    let arr = [];
    let obj = rowOnOffData?.applicableEmailTempId && rowOnOffData?.applicableTextTempId ? {
      "commMediumId": rowOnOffData?.commMediumId,
      "commChannelId": rowOnOffData?.commChannelId,
      "subtenantId": subtenantID,
      "applicableEmailTempId": rowOnOffData?.applicableEmailTempId,
      "applicableTextTempId": rowOnOffData?.applicableTextTempId,
      "occurrenceId": rowOnOffData?.occurrenceId,
      "isActive": e.target.checked === true ? true : false,
      "upsertedBy": rowOnOffData?.createdBy,
      "commMediumRoles": arr
    }
      : rowOnOffData?.applicableTextTempId ? {
        "commMediumId": rowOnOffData?.commMediumId,
        "commChannelId": rowOnOffData?.commChannelId,
        "subtenantId": subtenantID,
        // "applicableEmailTempId": rowOnOffData?.applicableEmailTempId,
        "applicableTextTempId": rowOnOffData?.applicableTextTempId,
        "occurrenceId": rowOnOffData?.occurrenceId,
        "isActive": e.target.checked === true ? true : false,
        "upsertedBy": rowOnOffData?.createdBy,
        "commMediumRoles": arr
      }
        : rowOnOffData?.applicableEmailTempId ? {
          "commMediumId": rowOnOffData?.commMediumId,
          "commChannelId": rowOnOffData?.commChannelId,
          "subtenantId": subtenantID,
          "applicableEmailTempId": rowOnOffData?.applicableEmailTempId,
          // "applicableTextTempId": rowOnOffData?.applicableTextTempId,
          "occurrenceId": rowOnOffData?.occurrenceId,
          "isActive": e.target.checked === true ? true : false,
          "upsertedBy": rowOnOffData?.createdBy,
          "commMediumRoles": arr
        } : {}

    const promises = Services.postUpsertCommMediumApi(obj)
    promises.then((response) => {
      handleClose();
    }).catch((error) => {
      konsole.log("error", error);
    }).finally(() => {
      konsole.log("finish");
    });
  }

  const fromRoleNameFuction = (data) => {
    let arrData = [], newArr = [];
    let arrayNew = []
    arrData.push(data);
    for (let i = 0; i <= arrData[0].length - 1; i++) {
      newArr.push(arrData[0]?.[i]?.fromRoleName)
    }
    arrayNew.push([...new Set(newArr)].join(', '))
    return arrayNew
  }

  const ToRoleNameFuction = (data) => {
    let arrData = [], newArr = [];
    let ToArrData = []
    arrData.push(data);
    for (let i = 0; i <= arrData[0].length - 1; i++) {
      newArr.push(arrData[0]?.[i]?.toRoleName)
    }
    ToArrData.push([...new Set(newArr)].join(', '))
    return ToArrData
  }

  const filteredData = sortedData
    ? sortedData?.filter(d => d?.occurrenceDetails?.toLowerCase().includes(props?.search?.toLowerCase()))
    : [];

  const totalPages = Math.ceil(filteredData.length / pageSize)
  const paginatedData = filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize)

  const dtHeaderStyle = { color: '#333', fontWeight: 600, fontSize: '14px', background: '#fff', textAlign: 'start', padding: '6px 8px' }
  const dtBodyStyle = { color: '#333', fontSize: '13px', background: '', textAlign: 'start', fontWeight: 100, padding: '6px 8px', verticalAlign: 'middle' }
  const dtBodyStyleCenter = { color: '#333', fontSize: '13px', background: '', textAlign: 'start', fontWeight: 100, padding: '6px 8px', verticalAlign: 'middle' }

  return (
    <>
      <div style={{ border: '1px solid #ddd', marginTop: '12px', display: 'flex', flexDirection: 'column' }}>
        <div style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }}>
          <table className="table table-bordered mb-0 staff-table custom-striped-table" style={{ fontFamily: 'Open Sans, sans-serif', fontSize: '13px' }}>
            <thead style={{ position: 'sticky', top: -1, zIndex: 1, background: '#fff' }}>
              <tr>
                <th style={dtHeaderStyle}>Status</th>
                <th style={dtHeaderStyle}>Occurrence</th>
                <th style={dtHeaderStyle}>From</th>
                <th style={dtHeaderStyle}>To</th>
                <th style={dtHeaderStyle}>Medium</th>
                <th style={dtHeaderStyle}>Template</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData?.length > 0
                ? paginatedData?.map((data) => (
                  <tr key={data?.commMediumId || data?.occurrenceId}>
                    <td style={dtBodyStyle}>
                      <div className='d-flex justify-content-center align-items-center' style={{ marginTop: '2px' }}>
                        <label className="switch">
                          <input
                            className="switch-input"
                            type="checkbox"
                            defaultChecked={data?.isActive}
                            onClick={(e) => PutUpsertCommMediumApiFuctioniOnOFF(e, data)}
                          />
                          <span className="switch-label" data-on="On" data-off="Off"></span>
                          <span className="switch-handle"></span>
                        </label>
                      </div>
                    </td>
                    <td style={dtBodyStyle}>{data.occurrenceDetails}</td>
                    <td style={dtBodyStyleCenter}>{fromRoleNameFuction(data?.commMediumRoles)}</td>
                    <td style={dtBodyStyleCenter}>{ToRoleNameFuction(data?.commMediumRoles)}</td>
                    <td style={dtBodyStyleCenter}>
                      <div className='d-flex gap-2'>
                        {data.applicableEmailTempId ? <span>Email</span> : null}
                        {data.applicableEmailTempId && data.applicableTextTempId ? <span>&amp;</span> : null}
                        {data.applicableTextTempId ? <span>Text</span> : null}
                      </div>
                    </td>
                    <td style={dtBodyStyle}>
                      <span className='ms-2'
                        style={{ cursor: 'pointer', color: '#720c20', fontWeight: 500 }}
                        onClick={() => addEditModalFun(data)}
                      >
                        View
                      </span>
                    </td>
                  </tr>
                ))
                : <tr><td colSpan={6} style={{ textAlign: 'center', padding: '20px', color: '#777' }}>No matching records found.</td></tr>
              }
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', borderTop: '1px solid #ddd', background: '#fff' }}>
          <span style={{ fontSize: '13px', color: '#555' }}>
            Showing {filteredData?.length === 0 ? 0 : (currentPage - 1) * pageSize + 1} to {Math.min(currentPage * pageSize, filteredData.length)} of {filteredData.length} entries
          </span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <button
              onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
              style={{ width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px', background: '#fff', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', color: '#555' }}
            >‹</button>

            {(() => {
              const pages = [];
              for (let p = 1; p <= totalPages; p++) {
                if (p === 1 || p === totalPages || (p >= currentPage - 1 && p <= currentPage + 1)) {
                  pages.push(p);
                }
              }
              const result = [];
              pages.forEach((p, i) => {
                if (i > 0 && p - pages[i - 1] > 1) result.push('ellipsis-' + p);
                result.push(p);
              });
              return result?.map((p) =>
                String(p).startsWith('ellipsis')
                  ? <span key={p} style={{ padding: '0 4px', fontSize: '13px' }}>...</span>
                  : <button
                    key={p}
                    onClick={() => setCurrentPage(p)}
                    style={{
                      width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px',
                      background: currentPage === p ? '#720c20' : '#fff',
                      color: currentPage === p ? '#fff' : '#555',
                      cursor: 'pointer', fontSize: '13px'
                    }}
                  >{p}</button>
              );
            })()}

            <button
              onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages || totalPages === 0}
              style={{ width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px', background: '#fff', cursor: (currentPage === totalPages || totalPages === 0) ? 'not-allowed' : 'pointer', color: '#555' }}
            >›</button>
          </div>
        </div>
      </div>

      {showAddModal &&
        <Viewandupdatemodal
          selectedRowData={selectedRowData}
          inblidEmailTemplate={inblidEmailTemplate}
          showAddModal={showAddModal}
          setShowAddModal={setShowAddModal}
          GetCommMediumPathApiFuction={props.GetCommMediumPathApiFuction}
          setupdateTableData={setupdateTableData}
        />
      }
    </>
  );
}

export default BasicExample;
